import { Controller } from '@hotwired/stimulus'
import Formatter from '../../lib/formatter'

export default class extends Controller {
  static targets = ['flash', 'input']

  input (e) {
    const input = e.target

    this.clearFlash()
    this.clearInputError(input)
    this.toggleInputFilled(input)
    this.applyFormat(input)
    this.enforceInputMaxlength(input)

    input.dataset.previousValue = input.value
  }

  blur () {
    // Leave this here or fields generate with FestaLabFormBuilder will throw errors
  }

  clearFlash () {
    this.flashTargets.forEach(flash => {
      flash.remove()
    })
  }

  clearInputError (input) {
    input.parentNode.querySelectorAll('.field_with_errors').forEach(element => {
      element.classList.remove('field_with_errors')
    })

    const message = input.parentNode.nextElementSibling
    if (!!message && message.classList.contains('error')) message.remove()
  }

  toggleInputFilled (input) {
    input.classList.toggle('filled', !!input.value)
  }

  applyFormat (input) {
    const format = input.dataset.formatter
    if (!format || this.isUserDeleting(input)) return

    const result = Formatter.apply(format, input.value)
    const length = result.length

    input.value = result.substr(0, input.maxLength || length)

    if (input.type === 'text') {
      input.focus()
      input.setSelectionRange(length, length)
    }
  }

  enforceInputMaxlength (input) {
    const maxlength = input.dataset.maxlength
    const value = input.value

    if (!!maxlength && value.length >= maxlength) input.value = value.substr(0, maxlength)
  }

  isUserDeleting (input) {
    const previous = input.dataset.previousValue || ''
    return previous.length > input.value.length
  }
}
